import React, { useCallback, useContext, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { notBlank } from "../../../util/ext";
import { MediaContext } from "../../common/media-context";

import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import EditColumn from "../../common/EditColumn";
import Image from "../../../components/Image";
import ThumbnailDialog from "../../common/ThumbnailDialog";

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },

  item: {
    padding: theme.spacing(0, 8, 8, 8),
  },

  thumbnailOverlay: {
    height: "150px",
    width: "150px",
    position: "relative",
    borderRadius: "20px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
    backgroundColor: "#E5E5E5",
  },

  thumbnailEdit: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
  },

  emptyThumbnail: {
    fontSize: "120px",
    color: theme.palette.disabled,
    position: "absolute",
    right: "15px",
    top: "15px",
  },

  editIcon: {
    color: "white",
  },

  locked: {
    marginLeft: theme.spacing(2),
  },
}));

const EditOrganizationLogoOverlay = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const { accept, showAlert, uploader } = props;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [uploading, setUploading] = useState(false);

  const onEditClick = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCancel = useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleSave = useCallback(
    (url, file) => {
      setUploading(true);
      console.log("Uploading...");
      uploader.mutate({
        resourceIds: { id: context.media.id },
        data: file,
      });

      if (!uploader.isPending) {
        console.log("Upload Complete...");
        setUploading(false);
        if (uploader.isError && notBlank(showAlert)) {
          showAlert("error", [uploader.error.message]);
        } else {
          setDialogOpen(false);

          console.log("Setting new org log url...");
          context.setOrgLogoUrl(url);
          if (notBlank(showAlert)) {
            showAlert("success", ["Content Successfully Saved"]);
          }
        }
      }
    },
    [context, showAlert, uploader],
  );

  const formBuilder = useCallback(
    handlers => {
      return (
        <Box ml={2}>
          <Box mb={4}>
            <Typography variant="h6" noWrap>
              Organization Logo
            </Typography>
          </Box>
          <div style={{ marginLeft: 10 }} className={classes.thumbnailOverlay}>
            <Image
              src={context.orgLogoUrl}
              alt="Organization logo"
              height={150}
              width={150}
            />
            <IconButton
              color="primary"
              classes={{ root: classes.thumbnailEdit }}
              onClick={onEditClick}
              size="large"
            >
              <EditIcon fontSize="large" classes={{ root: classes.editIcon }} />
            </IconButton>
            <ThumbnailDialog
              visible={dialogOpen}
              uploading={uploading}
              currentUrl={context.media.organizationLogoUrl}
              aspectRatio={1}
              accept={accept}
              hasThumbnailLock={false}
              onCancel={handleCancel}
              onSave={handleSave}
            />
          </div>
        </Box>
      );
    },
    [
      accept,
      context.media,
      context.orgLogoUrl,
      classes,
      dialogOpen,
      uploading,
      handleSave,
      handleCancel,
      onEditClick,
    ],
  );

  return <EditColumn className={classes.item} formBuilder={formBuilder} />;
};

export default EditOrganizationLogoOverlay;
